import isEqual from 'lodash-es/isEqual';
import merge from 'lodash-es/merge';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';

import pick from 'lodash-es/pick';
import each from 'lodash-es/each';
import cloneDeep from 'lodash-es/cloneDeep';

import getDisabledStyle from '../css/disabledStyle';
import updateStyle from '../css/updateStyle';

import lookAndFeel from '../lookAndFeel';
import uniqueId from '../uniqueId';
import updateStyleByRef from '../css/updateStyleByRef';
import ChoicesLib from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
import frameProps from '../css/frameProps';

import {
  getDefaultControl,
  updateChoicesClasses,
  getDefaultControlStyle,
} from './choices.defaults';

import Control from './control';

export default class Choices extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);

    // Add placeholderValue as an API property with formatter support
    this.addApi(this, 'placeholderValue', () =>
      this._checkDataOption('placeholderValue', this._controlOptions.placeholderValue || 'start typing to filter options'), {
      formatter: 'placeholderValueFormatter'
    });

    // Override text to use the formatted placeholderValue
    this.addApi(this, 'text', () => this.placeholderValue);
  }

  onReady(){
    this.addTrigger('change', ()=>{
      this._value = normalizeOptions(this._value);
    });
    super.onReady();
  }

  getOptions(){
    // Return options as a Map with value as key and label as value
    const optionsMap = new Map();
    if (this._controlOptions.options) {
      const normalized = normalizeOptions(this._controlOptions.options);
      normalized.forEach(option => {
        optionsMap.set(option.value, option.label);
      });
    }
    return optionsMap;
  }

  setOptions(options){
    // Accept Map, array of {label, value}, or array of strings
    let optionsArray = [];

    if (options instanceof Map) {
      // Convert Map to array of {label, value}
      options.forEach((label, value) => {
        optionsArray.push({ label, value });
      });
    } else if (Array.isArray(options)) {
      optionsArray = options;
    } else {
      console.error('setOptions expects a Map or array', options);
      return;
    }

    this._controlOptions.options = optionsArray;
    this.render();
  }

  addChoice(choice){
    // const options = this.getOption('options').map(r=>r);
    this._controlOptions.options.push(choice);
    // this.setOption('options',options);    
  }

  removeChoice(choice){
    this.deselectChoice(choice);
    // const options = this.getOption('options').filter(r=>{
    //   const cmp = normalizeOptions([r,choice]);
    //   return cmp[0].label!==cmp[1].label && cmp[0].value!==cmp[1].value;
    // });    
    // this.setOption('options',options);
    _.remove(this._controlOptions.options,r=>{
      const cmp = normalizeOptions([r,choice]);
      return cmp[0].label===cmp[1].label && cmp[0].value===cmp[1].value;
    });
  }

  deselectChoice(choice){
    this.value = this.value.filter(r=>{
      const cmp = normalizeOptions([r,choice]);
      return cmp[0].label!==cmp[1].label && cmp[0].value!==cmp[1].value;
    });

    this.render();
  }

  selectChoice(choice){
    choice = normalizeOptions([choice])[0];
    if(!this.value.some(r=>{
      const cmp = normalizeOptions([r,choice]);
      return cmp[0].label===cmp[1].label && cmp[0].value===cmp[1].value;
    })){
      this.value.push(choice);
      // Sort the value array by label
      this.value.sort(function(a, b) {
        return a.label.localeCompare(b.label);
      });
    }

    this.render();
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    // const options = this.options;
    const instance = this.instance;
    const path = this.path;    

    if (!control.el) {
      control.el = getDefaultControl(control);
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-choices-',Choices);
        control.styleSheet = 'css-' + control.id;        
      }else{
        control.el.setAttribute('id',control.id);
      }

      var bodyEl = control.el.getElementsByClassName('body')[0];
      if (!control.isLayoutMode) {
        bodyEl.addEventListener('showDropdown', (ev) => {
          control.isExpanded = true;
          control.el.style.zIndex = 100500;
          control.raiseEvent('isExpanded',{value:true,oldValue:false},ev);
        });

        bodyEl.addEventListener('hideDropdown', (ev) => {
          control.isExpanded = false;
          control.el.style.zIndex = 1;
          control.raiseEvent('isExpanded',{value:false,oldValue:true},ev);
        });

        bodyEl.addEventListener('change', (ev) => {
          //console.log('choices change', control.choices.getValue());
          var newValue = control.choices
            .getValue()
            .map((v) => ({ label: v.label, value: v.value }))
            .sort(function(a, b) {
              return a.label.localeCompare(b.label);
            });
          
          control.value = newValue;
          
          // Force the choices library to re-render with sorted order
          control.choices.removeActiveItems();
          control.choices.setChoiceByValue(_.map(newValue, 'value'));
          
          // updateDataSourceParameter(control, options, instance);
          //control.raiseEvent('change',{value:control.value}, ev);
          if (options.trigger) {
            if (!isFunction(options.trigger)) {
              console.error('choices change trigger should be a function', options.trigger);
            } else {
              options.trigger.apply(this, [options, instance, control, path, ev]);
            }
          }

          if (options.event) {
            if (!isString(options.event)) {
              console.error('choices change event should be a string', options.event);
            } else {
              instance.fire(
                options.event,
                pick(options, ['name', 'options', 'type', 'gridElement']),
                control,
                path,
                ev
              );
            }
          }

          control.doResetReload();
        });
      }
    } else {
      bodyEl = control.el.getElementsByClassName('body')[0];
    }

    if (!options.value) {
      options.value = {};
    }

    if (options.data && options.data.defaultValue !== undefined) {
      options.value.defaultValue = options.data.defaultValue;
    }

    if (options.data && options.data.options !== undefined) {
      options.options = (options.data.options + '').split(',');
    }

    if (!options.value.defaultValue) {
      options.value.defaultValue = [];
    }

    options.value.defaultValue = normalizeOptions(options.value.defaultValue);

    updateChoicesClasses(control, options);
    var stylePatch = {};

    var defaultStyle = getDefaultControlStyle();

    merge(stylePatch, defaultStyle.normal);

    if (options.style && options.style.normal) {
      merge(stylePatch, pick(options.style.normal, frameProps));
    }

    merge(stylePatch, control.frameStyle);

    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (options.style && options.style.disabled) {
        merge(stylePatch, options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }
    }

    let scheme = lookAndFeel(options.lookAndFeel, stylePatch.height);
    // console.log('scheme', options.lookAndFeel, scheme);
    updateStyleByRef(stylePatch, scheme);
    // stylePatch.height = 'auto';
    if (control.isExpanded) {
      stylePatch.zIndex = 100500;
    }

    updateStyle(control.el, stylePatch, control.currentStyle);

    control.currentStyle = stylePatch;
    let settings = merge(
      {
        itemSelectText: '',
        removeItemButton: true,
        placeholderValue: 'start typing to filter options',
      },
      pick(options, [
        'renderChoiceLimit',
        'maxItemCount',
        'removeItemButton',
        'duplicateItemsAllowed',
        'paste',
        'searchFloor',
        'searchResultLimit',
        'shouldSort',
        'shouldSortItems',
        'noResultsText',
        'noChoicesText',
      ]),
      {
        placeholderValue: control.text,
      }
    );
    if (
      !control.choices ||
      !isEqual(control.settings, settings) ||
      !isEqual(control.prevOptions, options.options)
    ) {
      control.settings = cloneDeep(settings);
      if (control.choices) {
        control.choices.destroy();
      }

      //control.reset();
      delete control.choicesData;
      control.prevOptions = cloneDeep(options.options);

      control.choices = new ChoicesLib(bodyEl, settings);
      if (control.isLayoutMode) {
        // console.log(control.el);
        control.el.getElementsByClassName('choices')[0].style.pointerEvents = 'none';
      }
    }

    // let selectedOptions = normalizeOptions(control.value);
    let selectedOptions = control.choices
      .getValue()
      .map((v) => ({ label: v.label, value: v.value }));

    const choicesData = [];
    each(options.options, function(d) {
      let o;
      if (isString(d)) {
        o = {
          label: d,
          value: d,
        };
      } else {
        o = {
          label: d.label || d.value,
          value: d.value || d.label,
        };
        if (d.disabled) {
          o.disabled = true;
        }

        if (
          d.selected &&
          !options.value.defaultValue.some((so) => so.label == o.label && so.value == o.value)
        ) {
          options.value.defaultValue  = [...options.value.defaultValue,o];
        }
      }

      choicesData.push(o);
    });

    // Sort choicesData alphabetically by label
    choicesData.sort(function(a, b) {
      return a.label.localeCompare(b.label);
    });

    if (!isEqual(choicesData, control.choicesData) || !isEqual(selectedOptions, control.value)) {
      control.choicesData = choicesData;
      control.choices.clearChoices();
      control.choices.clearStore();
      control.choices.setChoices(
        choicesData,
        // choicesData.filter(
        //   (o) => !selectedOptions.some((so) => so.label == o.label && so.value == o.value)
        // ),
        undefined,
        undefined,
        true
      );
    }

    if (!isEqual(selectedOptions, control.value)) {
      // Sort control.value by label before setting (only if it's an array)
      if (Array.isArray(control.value)) {
        control.value = control.value.sort(function(a, b) {
          return a.label.localeCompare(b.label);
        });
      }

      control.choices.setChoiceByValue(_.map(control.value, 'value'));
    }

    return control.el;
  }
}

function normalizeOptions(options) {
  if (!options) {
    return;
  }

  if (isString(options)) {
    options = options.split(',');
  }

  options = options.map((so) => {
    if (isString(so)) {
      return {
        label: so,
        value: so,
      };
    }

    so.label = so.label || so.value;
    so.value = so.value || so.label;
    return so;
  });
  return options;
}
